<!-- 群SOP详情 -->
<template>
  <div>
    <el-page-header class="page-header" @back="goBack" content="群SOP">
    </el-page-header>
    <div class="container Mmain">
      <el-form ref="form" :model="form" :rules="rules" label-width="14.0rem">
        <el-form-item label="规则名称：" prop="rule_title">
          <el-input style="width: 40.0rem" v-model="form.rule_title" :maxlength="20" show-word-limit
            clearable=""></el-input>
        </el-form-item>
        <el-form-item label="选择客户群：" prop="chat_id">
          <div class="person">
            <el-tag v-for="i of chat" style="margin: .0rem 1.2rem 0 0"  effect="plain" :key="i.id">
              <span> {{ i.name }} </span>
            </el-tag>
          </div>
          <el-button :style="{ marginTop: chat.length > 0 ? '.8rem' : '0' }" class="addBtn" icon="el-icon-plus"
             plain @click="addGroupChat">前往添加</el-button>
        </el-form-item>
        <el-form-item label="监督人：" prop="check_userid">
          <div class="person">
            <el-tag v-if="check_user.name" style="margin: 1.2rem 1.2rem 0 0"  effect="plain">
              {{ check_user.name }}
            </el-tag>
          </div>
          <el-button :style="{ marginTop: check_user.name ? '.8rem' : '0' }" plain icon="el-icon-plus"
            @click="onSelectCheckPerson">选择监督人</el-button>
        </el-form-item>
        <el-form-item label="群主推送：" prop="remind_time">
          <el-date-picker v-model="form.remind_time" type="datetime" placeholder="选择推送提醒时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="监督人员推送：" prop="check_time">
          <el-date-picker v-model="form.check_time" type="datetime" placeholder="选择推送提醒时间" time-arrow-control>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="内容标题：" prop="title">
          <el-input style="width: 40.0rem" v-model="form.title" placeholder="请输入内容标题" clearable=""></el-input>
        </el-form-item>
        <el-form-item label="推送类型：" prop="type">
          <el-radio-group v-model="form.type" @change="changeType">
            <el-radio label="文本">文本</el-radio>
            <el-radio label="图片">图片</el-radio>
            <el-radio label="视频">视频</el-radio>
            <el-radio label="文件">文件</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="推送内容：">
          <el-input v-if="form.type == '文本'" style="width: 40.0rem" autosize="true" type="textarea" v-model="form.content"
            placeholder="请输入推送内容" clearable=""></el-input>
          <template v-else>
            <el-upload style="width: 30%" class="upload-demo" :action="
              this.axios.defaults.baseURL +
              '/api/Alioss/upload_temp_uploadimg'
            " :data="upParams" :on-progress="handleProgress" :on-success="handleSuccess" :on-error="handleError"
              :on-remove="handleRemove" :before-remove="beforeRemove" :file-list="fileList" :list-type="listType"
              :accept="accept" :limit="1">
              <el-button type="primary" plain icon="el-icon-upload">
                上传文件
              </el-button>
              <div slot="tip" class="el-upload__tip">{{ tip }}</div>
            </el-upload>
          </template>
        </el-form-item>
      </el-form>
      <div class="form-footer" >
        <el-button type="primary" v-if="this.$route.query.id" :loading="btnLoading" :disabled="btnLoading" @click="submitForm('form')">确定编辑</el-button>
        <el-button type="primary" v-else :loading="btnLoading" :disabled="btnLoading" @click.once="submitForm('form')">立即创建</el-button>
        <!-- <el-button @click="goBack">取消</el-button> -->
      </div>
    </div>

    <right-group ref="drawer" :selectData="selectData" :checkbox="checkbox" @handleSelect="handleSelect"></right-group>
    <right-people ref="dialog" :selectData="selectData" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import rightGroup from '@/components/drawer/rightGroup';
import rightPeople from '@/components/drawer/rightPeople';
export default {
  name: "groupSopDetail",
  components: {
    rightGroup,
    rightPeople
  },
  data() {
    return {
      module: "",
      selectData: [],
      form: {
        rule_title: "",
        chat_id: "",
        check_userid: "",
        check_time: "",
        remind_time: "",
        content: "",
        type: "文本",
        url: "",
        media_id: "",
      },
      rules: {
        rule_title: [
          { required: true, message: "请输入规则名称", trigger: "blur" },
        ],
        chat_id: [{ required: true, message: "请选择群聊", trigger: "blur" }],
        check_userid: [
          { required: true, message: "请选择监督人员", trigger: "blur" },
        ],
        check_time: [
          {
            required: true,
            message: "请选择监督人员推送提醒时间",
            trigger: "blur",
          },
        ],
        remind_time: [
          {
            required: true,
            message: "请选择群主推送提醒时间",
            trigger: "blur",
          },
        ],
      },
      checkbox: true,
      chat: [],
      check_user: {},
      selectionDepartment: true,
      selectionlable: false,
      upParams: {},
      fileList: [],
      listType: "",
      accept: "",
      tip: "",
      btnLoading: false
    };
  },
  computed: {},

  mounted() {
    this.upParams.account_id = this.tooken.account_id;
    if (this.$route.query.id) {
      this.getData();
    }
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async getData() {
      const { data: res } = await this.axios({
        url: `/crm/GroupSop/getList`,
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id: this.$route.query.id,
        }),
      });
      console.log(res);
      if (res.code == 1) {
        const d = res.data.data[0];
        this.form.rule_title = d.rule_title;
        this.form.chat_id = d.chat_id;
        this.form.check_userid = d.check_userid;
        this.form.check_time = new Date(d.check_time * 1000);
        this.form.remind_time = new Date(d.remind_time * 1000);
        this.form.title = d.title;
        this.form.type = d.type;
        this.form.content = d.content;
        this.form.url = d.url;
        this.form.media_id = d.media_id;
        const chatUserId = d.chat_id.split(',')
        this.chat = d.chat_user_arrays.map((i, index) => {
          return {
            name: i.chat_names,
            id: chatUserId[index]
          }
        })

        this.check_user = {
          userid: d.check_userid,
          name: d.check_userid_name,
        };

        this.setAccept();

        this.fileList.push({
          url: this.form.url,
          name: this.form.url,
        });
      }
    },
    addGroupChat() {
      this.selectData = this.chat
      this.selectionDepartment = false;
      this.selectionlable = true;
      this.checkbox = true;
      this.module = "getClientBaseListGroupSop";
      this.$refs.drawer.open();
    },
    onSelectCheckPerson() {
      this.selectionlable = false;
      this.selectData = this.check_user
      this.selectionDepartment = true;
      this.checkbox = false;
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      switch (this.module) {
        case "getClientBaseListGroupSop":
          this.chat = person;
          const chatid = this.chat.map((i) => {
            return i.chat_id;
          });
          this.form.chat_id = String(chatid);
          break;
        case "getAddressBook":
          this.check_user = person;
          this.form.check_userid = this.check_user.userid;
          break;
        default:
          break;
      }
    },
    handleProgress(event) {
      this.btnLoading = true
    },
    handleSuccess(response, file, fileList) {
      this.btnLoading = false
      if (response.code == 0) {
        this.$message({
          message: response.msg,
          type: "error",
        });
        this.form.url = "";
        this.form.media_id = "";
        this.fileList = [];
        return;
      }
      this.$message({
        message: response.msg,
        type: "success",
      });
      this.form.url = response.data.url;
      this.form.media_id = response.data.media_id;
      this.fileList.push(this.form.url);

    },
    handleError(response) {
      this.btnLoading = false
      this.$message({
        message: response.msg,
        type: "success",
      });
    },
    beforeRemove(file, fileList) {
      this.form.file = [];
      this.fileList = [];
    },
    changeType() {
      this.form.content = "";
      this.form.url = "";
      this.form.media_id = "";
      this.fileList = [];
      this.setAccept();
    },
    setAccept() {
      switch (this.form.type) {
        case "图片":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          break;
        case "视频":
          this.listType = "text";
          this.tip = "只能上传MP4格式文件，且不超过10MB";
          this.accept = ".mp4";
          this.upParams.type = 2;
          break;
        case "文件":
          this.listType = "text";
          this.tip = "不能超过20MB";
          this.accept = "";
          this.upParams.type = 3;
          break;
        default:
          break;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    submit() {
      const url = this.$route.query.id ? "edit" : "add";
      let check_time;
      let remind_time;
      if (this.form.check_time) {
        check_time = Number.parseInt(this.form.check_time.getTime() / 1000);
      }
      if (this.form.remind_time) {
        remind_time = Number.parseInt(this.form.remind_time.getTime() / 1000);
      }
      if (this.form.url == '') {
        this.form.type = ''
      }
      this.axios
        .post(
          `/crm/GroupSop/${url}`,
          this.qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            id: this.$route.query.id,
            rule_title: this.form.rule_title,
            chat_id: this.form.chat_id,
            check_userid: this.form.check_userid,
            check_time,
            remind_time,
            type: this.form.type,
            content: this.form.content,
            title: this.form.title,
            url: this.form.url,
            media_id: this.form.media_id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.$router.go(-1);
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    handleRemove(file, fileList) {
      this.form.url = "";
      this.form.media_id = "";
      this.form.name = ''
      this.form.file = [];
      this.fileList = [];
    }
  },
};
</script>
<style  scoped>
.form-footer {
  margin-top: 4.0rem;
  padding-top: 4.0rem;
  border-top: .1rem solid #ebeef5;
  padding-left: 4.5rem;

}
.Mmain{
  background-color: #ffffff;
  border-radius: .8rem;
  padding: 4.0rem 2.0rem;

}
.el-form-item{
margin-bottom: 4.0rem;
}
</style>
